<template>
  <component :is="tag" class="notice-text">
    <i class="el-icon-warning-outline" />
    <slot>{{ text }}</slot>
  </component>
</template>

<script>
export default {
  name: "NoticeText",
  props: {
    text: {
      type: String,
      default: ''
    },
    inline: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    tag() {
      return this.inline ? 'span' : 'div'
    }
  }
}
</script>

<style scoped>
.notice-text {
  text-align: left;
  font-size: 13px;
  font-weight: bold;
  color: #999;
  margin-bottom: 10px;
}
.notice-text i {
  margin-right: 4px;
}
</style>
